import type { Permission } from '@ztechapps/common.contract'

export const customerPermissions = {
  canView: {
    value: 'customer.canView',
    label: 'Can View',
    description: 'No modification can be done to the customer, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'customer.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of customer',
  } satisfies Permission,
  canDelete: {
    value: 'customer.canDelete',
    label: 'Can Delete',
    description:
      'Can delete the records for all fields of customer. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
